module.exports = __webpack_public_path__ + "static/media/dolly-aapl.dbab4dba.svg";